<template lang="pug">
InheritWrapper(v-model="inherit" :readonly="innerSetting.ReadOnly || disabled")
  BriqTextarea(
    :label="innerSetting.DisplayName"
    :help="innerSetting.Description"
    v-model="innerValue"
    :error="fieldError"
    :disabled="innerSetting.ReadOnly || disabled ? true : inherit"
    :required="this.$attrs.required"
    :hideOptionalMarker="true"
  )
</template>

<script>
import InheritWrapper from '@v/settings/application/advanced/InheritWrapper.vue'
import setupInheritedField from './setupInheritedField.js'
import { toRefs } from '@vue/composition-api'
import mixin from '@v/settings/application/advanced/mixin.js'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'MultiLineString',
  components: { InheritWrapper },
  mixins: [mixin],
  props: {
    setting: {
      type: Object,
      required: true,
    },
    disabled: Boolean,
  },
  validations() {
    return {
      innerValue: {
        required,
        $each: {
          required,
        },
      },
    }
  },
  setup: (props, { emit }) => {
    return toRefs(setupInheritedField({ props, emit }))
  },
}
</script>
